import {
  IManagerLegacyNavTranslations,
  IEventManagerHomeTranslations,
  IEventManagerExhibitorsTranslations,
  IEventManagerProductsTranslations,
  IEventManagerSessionsTranslations,
  IEventManagerExportsTranslations,
  IEventManagerEventsTranslations,
  IManagerTranslations,
} from '@/translations/default/managers';

const legacy_nav: Partial<IManagerLegacyNavTranslations> = {
  product_form: 'Job offers form',
  product_list: 'Job listing',
  product_categories: 'Job offer categories',
};

const home: Partial<IEventManagerHomeTranslations> = {
  products_subtitle: 'Number of jobs offers created',
};

const exhibitors: Partial<IEventManagerExhibitorsTranslations> = {
  products_limit_label: 'Job offer limit',
  products_limit_message: 'Maximum number of job offers this exhibitor can create',
};

const products: Partial<IEventManagerProductsTranslations> = {
  empty_list_form_subtitle: 'Create the job offer form',
  empty_list_categories_subtitle: 'Add job categories',
  empty_list_product_title: 'Job offer',
  empty_list_product_subtitle: 'Create a new job offer',
  title: 'Job offers available',
  subtitle: 'Number of jobs created',
};

const sessions: Partial<IEventManagerSessionsTranslations> = {
  // leave empty until needed
};

const exports: Partial<IEventManagerExportsTranslations> = {
  // leave empty until needed
};

const events: Partial<IEventManagerEventsTranslations> = {
  // leave empty until needed
};

const managers: DeepPartial<IManagerTranslations> = {
  legacy_nav,
  home,
  exhibitors,
  products,
  sessions,
  exports,
  events,
};

export default managers;
